// import React, { useState, useEffect } from 'react';
// import { Table, Button, Input, Space, Tag, Modal, Form, InputNumber, Select, message } from 'antd';
// import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
// import "antd/dist/reset.css";
// // 导入所有房间相关接口
// import { getAllRooms, getAllHouses, updateRoom, deleteRoom, addRoom } from '../../api'; 

// const RoomList = () => {
//   const [rooms, setRooms] = useState([]);
//   const [originRooms, setOriginRooms] = useState([]); // 原始房间数据
//   const [houses, setHouses] = useState([]); // 房源列表（下拉选择用）
//   const [loading, setLoading] = useState(false);
//   const [searchText, setSearchText] = useState('');
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [form] = Form.useForm();
//   const [editingRoom, setEditingRoom] = useState(null);

//   // 加载房源列表（下拉选择用）
//   const fetchHouses = async () => {
//     try {
//       const res = await getAllHouses();
//       if (res?.success && Array.isArray(res.data)) {
//         setHouses(res.data);
//       } else {
//         message.error('房源列表格式错误');
//       }
//     } catch (err) {
//       console.error('加载房源列表失败：', err);
//       message.error('加载房源列表失败，请稍后重试');
//     }
//   };

//   // 加载房间数据（包含押金、租客手机号）
//   const fetchRooms = async () => {
//     setLoading(true);
//     try {
//       const res = await getAllRooms();
//       console.log('接口返回房间数据：', res);
//       if (res?.success && Array.isArray(res.data)) {
//         setRooms(res.data);
//         setOriginRooms(res.data);
//         message.success(`加载成功 ${res.data.length} 个房间`);
//       } else {
//         message.error('房间数据格式错误');
//       }
//     } catch (err) {
//       console.error('接口请求失败：', err);
//       message.error('加载房间失败，请检查接口连接');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 组件挂载时加载数据
//   useEffect(() => {
//     fetchHouses();
//     fetchRooms();
//   }, []);

//   // 搜索房间（新增租客手机号搜索）
//   const handleSearch = () => {
//     if (!searchText.trim()) {
//       setRooms(originRooms);
//       return;
//     }
//     const filtered = originRooms.filter(room => 
//       room.number.includes(searchText) || 
//       room.houseName.includes(searchText) || 
//       room.houseId.toString().includes(searchText) || 
//       room.tenantId.toString().includes(searchText) ||
//       room.tenantPhone.includes(searchText) // 新增租客手机号搜索
//     );
//     setRooms(filtered);
//   };

//   // 打开新增/编辑弹窗（新增押金字段回显）
//   const showModal = (room = null) => {
//     setEditingRoom(room);
//     if (room) {
//       form.setFieldsValue({
//         houseId: room.houseId.toString(),
//         number: room.number,
//         price: room.price,
//         deposit: room.deposit || 0, // 回显押金
//         status: room.status,
//         tenantId: room.tenantId.toString() || '0',
//         tenantPhone: room.tenantPhone === '暂无租客' ? '' : room.tenantPhone, // 回显租客手机号
//         floor: room.floor,
//       });
//     } else {
//       form.resetFields();
//     }
//     setIsModalVisible(true);
//   };


//   // 提交表单（修复字段名映射）
// const handleSubmit = async () => {
//   try {
//     const values = await form.validateFields();
//     // 🔥 核心修复：映射字段名，和后端UpdateRoomReq结构体完全一致
//     const submitData = {
//       houseId: parseInt(values.houseId),
//       number: values.number,
//       floor: parseInt(values.floor),
//       price: parseFloat(values.price),
//       deposit: parseFloat(values.deposit || 0),
//       status: values.status,
//       tenantId: values.tenantId ? parseInt(values.tenantId) : 0,
//       tenantPhone: values.tenantPhone || ''
//     };

//     setLoading(true);
//     if (editingRoom) {
//       // 编辑：调用后端更新接口
//       console.log('编辑房间参数（最终提交）：', submitData);
//       const res = await updateRoom(editingRoom.id, submitData);
//       if (res?.success) {
//         message.success('编辑房间成功');
//         fetchRooms(); // 重新加载列表（关键！保证修改后数据刷新）
//       } else {
//         message.error('编辑房间失败：' + (res?.msg || '后端返回异常'));
//       }
//     } else {
//       // 新增逻辑不变
//       const res = await addRoom(submitData);
//       if (res?.success) {
//         message.success('新增房间成功');
//         fetchRooms();
//       } else {
//         message.error('新增房间失败：' + (res?.msg || '后端返回异常'));
//       }
//     }
//     setIsModalVisible(false);
//   } catch (err) {
//     console.error('提交失败：', err);
//     const errMsg = err.response?.data?.msg || err.message || '提交失败，请检查输入';
//     message.error(errMsg);
//   } finally {
//     setLoading(false);
//   }
// };

//   // // 提交表单（对接后端接口，新增/编辑房间）
//   // const handleSubmit = async () => {
//   //   try {
//   //     const values = await form.validateFields();
//   //     // 转换字段类型
//   //     values.houseId = parseInt(values.houseId);
//   //     values.price = parseFloat(values.price);
//   //     values.deposit = parseFloat(values.deposit || 0); // 押金转换
//   //     values.tenantId = values.tenantId ? parseInt(values.tenantId) : 0;
//   //     values.tenantPhone = values.tenantPhone || ''; // 租客手机号
//   //     values.floor = parseInt(values.floor);

//   //     setLoading(true);
//   //     if (editingRoom) {
//   //       // 编辑：调用后端更新接口
//   //       console.log('编辑房间参数：', values);
//   //       const res = await updateRoom(editingRoom.id, values);
//   //       if (res?.success) {
//   //         message.success('编辑房间成功');
//   //         fetchRooms(); // 重新加载列表
//   //       } else {
//   //         message.error('编辑房间失败：' + (res?.msg || '后端返回异常'));
//   //       }
//   //     } else {
//   //       // 新增：调用后端新增接口
//   //       console.log('新增房间参数：', values);
//   //       const res = await addRoom(values);
//   //       if (res?.success) {
//   //         message.success('新增房间成功');
//   //         fetchRooms(); // 重新加载列表
//   //       } else {
//   //         message.error('新增房间失败：' + (res?.msg || '后端返回异常'));
//   //       }
//   //     }
//   //     setIsModalVisible(false);
//   //   } catch (err) {
//   //     console.error('提交失败：', err);
//   //     const errMsg = err.response?.data?.msg || err.message || '提交失败，请检查输入';
//   //     message.error(errMsg);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   // 删除房间（对接后端接口）
//   const handleDelete = async (id) => {
//     console.log('触发删除房间逻辑：ID=', id);
//     if (!window.confirm('确定要删除该房间吗？删除后不可恢复！')) {
//       console.log('用户取消删除房间：ID=', id);
//       return;
//     }
    
//     try {
//       setLoading(true);
//       console.log('开始调用删除房间接口：ID=', id);
//       const res = await deleteRoom(id);
//       if (res?.success) {
//         console.log('删除房间成功：ID=', id);
//         message.success('删除房间成功');
//         fetchRooms(); // 重新加载列表
//       } else {
//         const errMsg = res?.msg || '删除房间失败：后端返回异常';
//         console.error(errMsg);
//         message.error(errMsg);
//       }
//     } catch (err) {
//       console.error('删除房间失败详情：', err);
//       const errMsg = err.response?.data?.msg || err.message || '删除房间失败：网络/接口问题';
//       message.error(errMsg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 表格列配置（新增押金、租客手机号）
//   const columns = [
//     { title: '房间ID', dataIndex: 'id', key: 'id', width: 80 },
//     { title: '所属房源', dataIndex: 'houseName', key: 'houseName', width: 180 },
//     { title: '所属房源ID', dataIndex: 'houseId', key: 'houseId', width: 100 },
//     { title: '房间号', dataIndex: 'number', key: 'number', width: 100 },
//     { title: '楼层', dataIndex: 'floor', key: 'floor', width: 80 },
//     { title: '租金(元/月)', dataIndex: 'price', key: 'price', width: 120, render: (price) => price.toFixed(2) },
//     { title: '押金(元)', dataIndex: 'deposit', key: 'deposit', width: 100, render: (deposit) => deposit.toFixed(2) }, // 新增押金列
//     { title: '租客ID', dataIndex: 'tenantId', key: 'tenantId', width: 100, render: (id) => id === 0 ? '暂无租客' : id },
//     { title: '租客手机号', dataIndex: 'tenantPhone', key: 'tenantPhone', width: 130 }, // 新增租客手机号列
//     {
//       title: '状态',
//       dataIndex: 'status',
//       key: 'status',
//       width: 100,
//       render: (status) => {
//         let color = 'green';
//         if (status === '已出租') color = 'blue';
//         if (status === '已退租') color = 'orange';
//         return <Tag color={color}>{status}</Tag>;
//       },
//     },
//     { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 180 },
//     {
//       title: '操作',
//       key: 'action',
//       render: (_, record) => (
//         <Space size="middle">
//           <Button icon={<EditOutlined />} size="small" onClick={() => showModal(record)}>编辑</Button>
//           <Button icon={<DeleteOutlined />} size="small" danger onClick={() => handleDelete(record.id)}>删除</Button>
//         </Space>
//       ),
//       width: 150,
//     },
//   ];

//   return (
//     <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
//       <h2 style={{ marginBottom: '20px', fontSize: '18px', fontWeight: 600 }}>房间管理</h2>
      
//       {/* 搜索+新增区域 */}
//       <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
//         <Space style={{ marginBottom: '10px' }}>
//           <Input
//             placeholder="搜索房间号、房源名称、房源ID、租客ID或租客手机号"
//             value={searchText}
//             onChange={(e) => setSearchText(e.target.value)}
//             style={{ width: 450 }}
//             onPressEnter={handleSearch}
//           />
//           <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>搜索</Button>
//           <Button type="default" onClick={() => { setSearchText(''); setRooms(originRooms); }}>重置</Button>
//         </Space>
//         <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal()}>新增房间（暂无此功能）</Button>
//       </div>

//       {/* 房间表格 */}
//       <Table
//         columns={columns}
//         dataSource={rooms}
//         rowKey="id"
//         loading={loading}
//         pagination={{ pageSize: 10, showSizeChanger: true, showTotal: (total) => `共 ${total} 条数据` }}
//         locale={{ emptyText: '暂无房间数据' }}
//         bordered
//         style={{ background: '#fff' }}
//         scroll={{ x: 1600 }} // 调整横向滚动宽度
//       />

//       {/* 新增/编辑弹窗（新增押金、租客手机号字段） */}
//       <Modal
//         title={editingRoom ? '编辑房间' : '新增房间'}
//         visible={isModalVisible}
//         onCancel={() => setIsModalVisible(false)}
//         onOk={handleSubmit}
//         width={600}
//         destroyOnClose
//         maskClosable={false} // 禁止点击遮罩关闭
//       >
//         <Form form={form} layout="vertical" initialValues={{ status: '未出租', deposit: 0 }}>
//           <Form.Item
//             name="houseId"
//             label="所属房源"
//             rules={[{ required: true, message: '请选择所属房源' }]}
//           >
//             <Select placeholder="选择房源">
//               {houses.map(house => (
//                 <Select.Option key={house.id} value={house.id.toString()}>
//                   {house.name}（房源ID：{house.id}）
//                 </Select.Option>
//               ))}
//             </Select>
//           </Form.Item>
//           <Form.Item
//             name="number"
//             label="房间号"
//             rules={[{ required: true, message: '请输入房间号' }]}
//           >
//             <Input placeholder="例如：301、502" maxLength={20} />
//           </Form.Item>
//           <Form.Item
//             name="floor"
//             label="楼层"
//             rules={[{ required: true, message: '请输入楼层' }]}
//           >
//             <InputNumber
//               placeholder="输入楼层"
//               min={1}
//               style={{ width: '100%' }}
//             />
//           </Form.Item>
//           <Form.Item
//             name="price"
//             label="租金(元/月)"
//             rules={[{ required: true, message: '请输入租金' }]}
//           >
//             <InputNumber
//               placeholder="输入租金"
//               min={100}
//               step={100}
//               style={{ width: '100%' }}
//             />
//           </Form.Item>
//           {/* 新增押金字段 */}
//           <Form.Item
//             name="deposit"
//             label="押金(元)"
//             rules={[{ required: true, message: '请输入押金' }]}
//           >
//             <InputNumber
//               placeholder="输入押金"
//               min={0}
//               step={100}
//               style={{ width: '100%' }}
//             />
//           </Form.Item>
//           <Form.Item
//             name="status"
//             label="状态"
//             rules={[{ required: true, message: '请选择状态' }]}
//           >
//             <Select placeholder="选择状态">
//               <Select.Option value="已出租">已出租</Select.Option>
//               <Select.Option value="未出租">未出租</Select.Option>
//               <Select.Option value="已退租">已退租</Select.Option>
//             </Select>
//           </Form.Item>
//           <Form.Item
//             name="tenantId"
//             label="租客ID"
//             rules={[{ required: ({ getFieldValue }) => getFieldValue('status') === '已出租', message: '已出租状态必须填写租客ID' }]}
//           >
//             <Input placeholder="例如：2001（未出租状态可留空）" maxLength={20} />
//           </Form.Item>
//           {/* 新增租客手机号字段 */}
//           <Form.Item
//             name="tenantPhone"
//             label="租客手机号"
//             rules={[{ 
//               required: ({ getFieldValue }) => getFieldValue('status') === '已出租', 
//               message: '已出租状态必须填写租客手机号' 
//             }, {
//               pattern: /^1[3-9]\d{9}$/, 
//               message: '请输入正确的手机号（已出租状态必填）' 
//             }]}
//           >
//             <Input placeholder="例如：13800138000（未出租状态可留空）" maxLength={11} />
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default RoomList;

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Button, Space, Tag, Modal, Form, InputNumber, Select, message, Input } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import "antd/dist/reset.css";
// 🔥 新增导入批量删除接口
import { getAllRooms, getAllHouses, updateRoom, deleteRoom, addRoom, batchDeleteRooms } from '../../api';
import ListToolbar from '../../components/ListToolbar';
import { exportToCSV } from '../../utils/exportUtils';
import {
  filterRoomList,
  getRoomSearchPlaceholder,
  ROOM_SEARCH_SCOPE_OPTIONS,
} from '../../utils/listSearch';
import PageTitle from '../../components/PageTitle';
import ResizableTable from '../../components/ResizableTable'; 

const RoomList = () => {
  const [rooms, setRooms] = useState([]);
  const [originRooms, setOriginRooms] = useState([]); 
  const [houses, setHouses] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchScope, setSearchScope] = useState('houseName');
  const [matchMode, setMatchMode] = useState('exact');
  const searchTextRef = useRef('');
  const searchScopeRef = useRef('houseName');
  const matchModeRef = useRef('exact');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingRoom, setEditingRoom] = useState(null);
  // 🔥 新增：存储勾选的房间ID
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [displayColumns, setDisplayColumns] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
  });
  const [houseSearchInput, setHouseSearchInput] = useState('');
  const [houseSearchApplied, setHouseSearchApplied] = useState('');

  useEffect(() => {
    searchTextRef.current = searchText;
  }, [searchText]);

  useEffect(() => {
    searchScopeRef.current = searchScope;
  }, [searchScope]);

  useEffect(() => {
    matchModeRef.current = matchMode;
  }, [matchMode]);

  const roomSearchPlaceholder = useMemo(
    () => getRoomSearchPlaceholder(searchScope),
    [searchScope],
  );

  const housesForSelect = useMemo(() => {
    const kw = houseSearchApplied.trim();
    if (!kw) return [];
    const isIdSearch = /^\d+$/.test(kw);
    return houses.filter((house) => {
      const name = String(house.name ?? '');
      const idStr = String(house.id ?? '');
      const address = String(house.address ?? '');
      if (isIdSearch) return idStr === kw;
      return name.includes(kw) || address.includes(kw);
    });
  }, [houses, houseSearchApplied]);

  const applyHouseSearch = () => {
    setHouseSearchApplied(String(houseSearchInput ?? '').trim());
  };

  const resetHouseSearch = () => {
    setHouseSearchInput('');
    setHouseSearchApplied('');
  };

  // 加载房源列表（不变）
  const fetchHouses = async () => {
    try {
      const res = await getAllHouses();
      if (res?.success && Array.isArray(res.data)) {
        setHouses(res.data);
      } else {
        message.error('房源列表格式错误');
      }
    } catch (err) {
      console.error('加载房源列表失败：', err);
      message.error('加载房源列表失败，请稍后重试');
    }
  };

  // 加载房间数据（不变）
  const fetchRooms = async () => {
    setLoading(true);
    try {
      const res = await getAllRooms();
      console.log('接口返回房间数据：', res);
      if (res?.success && Array.isArray(res.data)) {
        setOriginRooms(res.data);
        const filtered = filterRoomList(
          res.data,
          searchTextRef.current,
          searchScopeRef.current,
          matchModeRef.current,
        );
        setRooms(filtered);
        setPagination((prev) => ({ ...prev, current: 1 }));
        message.success(`加载成功 ${res.data.length} 个房间`);
      } else {
        message.error('房间数据格式错误');
      }
    } catch (err) {
      console.error('接口请求失败：', err);
      message.error('加载房间失败，请检查接口连接');
    } finally {
      setLoading(false);
    }
  };

  // 组件挂载时加载数据（不变）
  useEffect(() => {
    fetchHouses();
    fetchRooms();
  }, []);

  const handleSearch = () => {
    const kw = searchText.trim();
    if (!kw) {
      setRooms(originRooms);
      setPagination((prev) => ({ ...prev, current: 1 }));
      return;
    }
    const filtered = filterRoomList(originRooms, kw, searchScope, matchMode);
    setRooms(filtered);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  // 重置搜索（保留搜索范围）
  const handleReset = () => {
    setSearchText('');
    setMatchMode('exact');
    setRooms(originRooms);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  // 刷新数据
  const handleRefresh = () => {
    fetchRooms();
  };

  // 导出数据
  const handleExport = () => {
    const exportData = rooms.map(room => ({
      '房间ID': room.id,
      '房间号': room.number || '-',
      '房间地址': room.roomAddress || '-',
      '房源名称': room.houseName || '-',
      '房源ID': room.houseId,
      '楼层': room.floor || '-',
      '租金(元)': Number(room.price || 0).toFixed(2),
      '押金(元)': Number(room.deposit || 0).toFixed(2),
      '状态': room.status === 1 ? '已出租' : '未出租',
      '租客ID': room.tenantId || '-',
      '租客手机号': room.tenantPhone || '-',
    }));
    if (exportToCSV(exportData, '房间列表')) {
      message.success(`成功导出 ${exportData.length} 条数据`);
    } else {
      message.error('导出数据失败，请重试');
    }
  };

  // 打开新增/编辑弹窗（不变）
  const showModal = (room = null) => {
    setEditingRoom(room);
    resetHouseSearch();
    if (room) {
      form.setFieldsValue({
        houseId: Number(room.houseId),
        number: room.number,
        roomAddress: room.roomAddress || '',
        price: room.price,
        deposit: room.deposit || 0,
        status: room.status,
        tenantId: room.tenantId.toString() || '0',
        tenantPhone: room.tenantPhone === '暂无租客' ? '' : room.tenantPhone,
        floor: room.floor,
        roomPrefix: '',
        rent_pay_daily_limit: room.rent_pay_daily_limit ?? null,
        rent_pay_monthly_limit: room.rent_pay_monthly_limit ?? null,
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ status: '未出租' });
    }
    setIsModalVisible(true);
  };

  // 提交表单（不变）
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const houseId = Number(values.houseId);
      const floor = Number(values.floor);
      if (!Number.isFinite(houseId) || houseId <= 0) {
        message.error('请输入有效的所属房源ID');
        return;
      }
      if (!Number.isFinite(floor) || floor < 1) {
        message.error('请填写有效的楼层（≥1）');
        return;
      }
      const submitData = editingRoom
        ? {
            houseId,
            number: String(values.number ?? '').trim(),
            roomAddress: String(values.roomAddress ?? '').trim(),
            floor,
            price: parseFloat(values.price),
            deposit: parseFloat(values.deposit || 0),
            status: values.status,
            tenantId: values.tenantId ? parseInt(values.tenantId, 10) : 0,
            tenantPhone: values.tenantPhone || '',
            rent_pay_daily_limit:
              values.rent_pay_daily_limit === undefined || values.rent_pay_daily_limit === null || values.rent_pay_daily_limit === ''
                ? 0
                : parseFloat(values.rent_pay_daily_limit),
            rent_pay_monthly_limit:
              values.rent_pay_monthly_limit === undefined || values.rent_pay_monthly_limit === null || values.rent_pay_monthly_limit === ''
                ? 0
                : parseFloat(values.rent_pay_monthly_limit),
          }
        : {
            houseId,
            number: String(values.number ?? '').trim(),
            floor,
            roomPrefix: String(values.roomPrefix ?? '').trim(),
            status: '未出租',
            price: 0,
            deposit: 0,
            tenantId: 0,
            tenantPhone: '',
          };

      setLoading(true);
      if (editingRoom) {
        const res = await updateRoom(editingRoom.id, submitData);
        if (res?.success) {
          message.success('编辑房间成功');
          fetchRooms();
        } else {
          message.error('编辑房间失败：' + (res?.msg || '后端返回异常'));
        }
      } else {
        const res = await addRoom(submitData);
        if (res?.success) {
          message.success('新增房间成功');
          fetchRooms();
        } else {
          message.error('新增房间失败：' + (res?.msg || '后端返回异常'));
        }
      }
      setIsModalVisible(false);
    } catch (err) {
      console.error('提交失败：', err, err.response?.data);
      const errMsg =
        err.response?.data?.msg ||
        err.response?.data?.error ||
        err.message ||
        '提交失败，请检查输入';
      if (!err.response?.data?.msg && !err.response?.data?.error) {
        message.error(errMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  // 删除单个房间（不变）
  const handleDelete = async (id) => {
    console.log('触发删除房间逻辑：ID=', id);
    if (!window.confirm('确定要删除该房间吗？删除后不可恢复！')) {
      console.log('用户取消删除房间：ID=', id);
      return;
    }
    
    try {
      setLoading(true);
      console.log('开始调用删除房间接口：ID=', id);
      const res = await deleteRoom(id);
      if (res?.success) {
        console.log('删除房间成功：ID=', id);
        message.success('删除房间成功');
        fetchRooms();
      } else {
        const errMsg = res?.msg || '删除房间失败：后端返回异常';
        console.error(errMsg);
        message.error(errMsg);
      }
    } catch (err) {
      console.error('删除房间失败详情：', err);
      const errMsg = err.response?.data?.msg || err.message || '删除房间失败：网络/接口问题';
      message.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  // 🔥 新增：批量删除房间逻辑
  const handleBatchDelete = async () => {
    console.log('触发批量删除房间：选中ID=', selectedRowKeys);
    if (selectedRowKeys.length === 0) {
      message.warning('请先勾选要删除的房间！');
      return;
    }
    if (!window.confirm(`确定要删除选中的 ${selectedRowKeys.length} 个房间吗？删除后不可恢复！`)) {
      console.log('用户取消批量删除房间');
      return;
    }

    try {
      setLoading(true);
      const res = await batchDeleteRooms(selectedRowKeys);
      if (res?.success) {
        message.success(`批量删除成功！共删除 ${selectedRowKeys.length} 个房间`);
        fetchRooms(); // 刷新列表
        setSelectedRowKeys([]); // 清空勾选
      } else {
        const errMsg = res?.msg || '批量删除房间失败：后端返回异常';
        console.error(errMsg);
        message.error(errMsg);
      }
    } catch (err) {
      console.error('批量删除房间失败详情：', err);
      const errMsg = err.response?.data?.msg || err.message || '批量删除房间失败：网络/接口问题';
      message.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  // 🔥 新增：表格勾选配置
  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => {
      console.log('勾选房间ID变化：', keys);
      setSelectedRowKeys(keys);
    },
  };

  const handleTableChange = (newPagination) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    }));
  };

  const pagedRooms = rooms.slice(
    (pagination.current - 1) * pagination.pageSize,
    pagination.current * pagination.pageSize
  );

  // 原始表格列配置
  const originalColumns = [
    { title: '房间ID', dataIndex: 'id', key: 'id', width: 70 },
    { title: '所属房源', dataIndex: 'houseName', key: 'houseName', width: 150 },
    { title: '所属房源ID', dataIndex: 'houseId', key: 'houseId', width: 80 },
    { title: '房间号', dataIndex: 'number', key: 'number', width: 90 },
    { title: '房间地址', dataIndex: 'roomAddress', key: 'roomAddress', width: 140, render: (v) => v || '-' },
    { title: '楼层', dataIndex: 'floor', key: 'floor', width: 70 },
    { title: '租金(元/月)', dataIndex: 'price', key: 'price', width: 100, render: (price) => price.toFixed(2) },
    { title: '押金(元)', dataIndex: 'deposit', key: 'deposit', width: 90, render: (deposit) => deposit.toFixed(2) },
    { title: '租客ID', dataIndex: 'tenantId', key: 'tenantId', width: 80, render: (id) => id === 0 ? '暂无租客' : id },
    { title: '租客手机号', dataIndex: 'tenantPhone', key: 'tenantPhone', width: 120 },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 80,
      render: (status) => {
        let color = 'green';
        if (status === '已出租') color = 'blue';
        if (status === '已退租') color = 'orange';
        return <Tag color={color}>{status}</Tag>;
      },
    },
    { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 160 },
    {
      title: '操作',
      key: 'action',
      width: 140,
      render: (_, record) => (
        <Space size="middle">
          <Button icon={<EditOutlined />} size="small" onClick={() => showModal(record)}>编辑</Button>
          <Button icon={<DeleteOutlined />} size="small" danger onClick={() => handleDelete(record.id)}>删除</Button>
        </Space>
      ),
    },
  ];

  // 从localStorage加载列设置并应用到表格（只处理隐藏）
  useEffect(() => {
    const storageKey = 'roomList_columnStates';
    const saved = localStorage.getItem(storageKey);
    let columnStates = {};
    
    if (saved) {
      try {
        columnStates = JSON.parse(saved);
      } catch (e) {
        console.error('Failed to parse column states:', e);
      }
    }
    
    // 根据列状态生成实际列配置（只处理隐藏）
    const processedColumns = originalColumns.map(col => {
      const state = columnStates[col.key];
      
      if (state === 'hidden') {
        return null;
      }
      
      return col;
    }).filter(col => col !== null);
    
    setDisplayColumns(processedColumns);
  }, []);

  return (
    <div style={{ padding: '20px 0' }}>
      <PageTitle title="房间管理" />
      
      {/* 统一的工具栏 */}
      <ListToolbar
        showMatchMode
        matchMode={matchMode}
        onMatchModeChange={setMatchMode}
        searchScopeOptions={ROOM_SEARCH_SCOPE_OPTIONS}
        searchScope={searchScope}
        onSearchScopeChange={setSearchScope}
        searchPlaceholder={roomSearchPlaceholder}
        searchValue={searchText}
        onSearchChange={setSearchText}
        onSearch={handleSearch}
        onReset={handleReset}
        onRefresh={handleRefresh}
        onExport={handleExport}
        showBatchDelete={true}
        selectedCount={selectedRowKeys.length}
        onBatchDelete={handleBatchDelete}
        showAdd={true}
        onAdd={() => showModal()}
      />

      {/* 房间表格 🔥 新增rowSelection开启勾选 */}
      <ResizableTable
        columns={displayColumns.length > 0 ? displayColumns : originalColumns}
        dataSource={pagedRooms}
        rowKey="id"
        loading={loading}
        storageKey="roomList"
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: rooms.length,
          showSizeChanger: true,
          showTotal: (total) => `共 ${total} 条数据`,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        onChange={handleTableChange}
        locale={{ emptyText: '暂无房间数据' }}
        bordered
        style={{ background: '#fff' }}
        scroll={{ x: 1600 }}
        rowSelection={rowSelection} // 🔥 开启勾选功能
      />

      {/* 新增/编辑弹窗 */}
      <Modal
        title={editingRoom ? '编辑房间' : '新增房间'}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleSubmit}
        width={600}
        destroyOnClose
        maskClosable={false}
      >
        <Form form={form} layout="vertical" initialValues={{ status: '未出租' }}>
          {editingRoom ? (
            <>
              <Form.Item name="houseId" label="所属房源ID">
                <InputNumber min={1} precision={0} disabled style={{ width: '100%' }} />
              </Form.Item>
              {editingRoom.houseName ? (
                <div style={{ marginTop: -12, marginBottom: 16, color: '#666', fontSize: 13 }}>
                  {editingRoom.houseName}
                </div>
              ) : null}
            </>
          ) : (
            <>
              <Form.Item
                name="houseId"
                label="所属房源ID"
                extra="可直接输入；也可在下方搜索后从列表选择（会同步填入此处）"
                rules={[
                  { required: true, message: '请输入或选择所属房源ID' },
                  {
                    validator: (_, val) => {
                      const n = Number(val);
                      if (Number.isFinite(n) && n > 0) return Promise.resolve();
                      return Promise.reject(new Error('房源ID须为正整数'));
                    },
                  },
                ]}
              >
                <InputNumber
                  placeholder="直接输入房源ID"
                  min={1}
                  precision={0}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item label="搜索房源">
                <Space.Compact style={{ width: '100%' }}>
                  <Input
                    placeholder="输入房产名或房源ID"
                    value={houseSearchInput}
                    onChange={(e) => setHouseSearchInput(e.target.value)}
                    onPressEnter={applyHouseSearch}
                    allowClear
                  />
                  <Button type="primary" icon={<SearchOutlined />} onClick={applyHouseSearch}>
                    搜索
                  </Button>
                </Space.Compact>
              </Form.Item>
              <Form.Item label="所属房源">
                <Select
                  placeholder={
                    houseSearchApplied
                      ? '选择后会填入上方房源ID'
                      : '可先搜索再选；也可跳过，直接填上方ID'
                  }
                  allowClear
                  disabled={!houseSearchApplied}
                  notFoundContent={houseSearchApplied ? '未找到匹配房源' : '请先搜索'}
                  onChange={(val) => {
                    if (val != null && val !== '') {
                      form.setFieldsValue({ houseId: Number(val) });
                    }
                  }}
                >
                  {housesForSelect.map((house) => (
                    <Select.Option key={house.id} value={house.id.toString()}>
                      {house.name}（房源ID：{house.id}）
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </>
          )}
          <Form.Item
            name="number"
            label="房间号"
            rules={[{ required: true, message: '请输入房间号' }]}
            extra={!editingRoom ? '不含前缀部分，如 301；完整房号 = 前缀 + 房间号' : undefined}
          >
            <Input placeholder="例如：301、502" maxLength={20} />
          </Form.Item>
          {editingRoom && (
            <Form.Item name="roomAddress" label="房间地址">
              <Input placeholder="选填，个别房间可填写具体地址" maxLength={200} />
            </Form.Item>
          )}
          {!editingRoom && (
            <Form.Item name="roomPrefix" label="房号前缀（选填）">
              <Input placeholder="不填则使用房源已配置的前缀" maxLength={20} />
            </Form.Item>
          )}
          <Form.Item
            name="floor"
            label="楼层"
            rules={[{ required: true, message: '请输入楼层' }]}
          >
            <InputNumber
              placeholder="输入楼层"
              min={1}
              style={{ width: '100%' }}
            />
          </Form.Item>
          {editingRoom && (
            <>
              <Form.Item
                name="price"
                label="租金(元/月)"
                rules={[{ required: true, message: '请输入租金' }]}
              >
                <InputNumber
                  placeholder="输入租金"
                  min={0}
                  step={1}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item
                name="deposit"
                label="押金(元)"
                rules={[{ required: true, message: '请输入押金' }]}
              >
                <InputNumber
                  placeholder="输入押金"
                  min={0}
                  step={100}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item
                name="status"
                label="状态"
                rules={[{ required: true, message: '请选择状态' }]}
              >
                <Select placeholder="选择状态">
                  <Select.Option value="已出租">已出租</Select.Option>
                  <Select.Option value="未出租">未出租</Select.Option>
                  <Select.Option value="已退租">已退租</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="tenantId"
                label="租客ID"
              >
                <Input placeholder="例如：2001（未出租状态可留空）" maxLength={20} />
              </Form.Item>
              <Form.Item
                name="tenantPhone"
                label="租客手机号"
                rules={[{
                  pattern: /^1[3-9]\d{9}$/,
                  message: '请输入正确的手机号',
                }]}
              >
                <Input placeholder="例如：13800138000（未出租状态可留空）" maxLength={11} />
              </Form.Item>
              <Form.Item
                name="rent_pay_daily_limit"
                label="本房间日限额（元）"
                extra="留空则跟随房源「各房间默认每日限额」"
              >
                <InputNumber
                  placeholder="空=用房源默认"
                  min={0}
                  step={100}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item
                name="rent_pay_monthly_limit"
                label="本房间月限额（元）"
                extra="留空则跟随房源「各房间默认每月限额」"
              >
                <InputNumber
                  placeholder="空=用房源默认"
                  min={0}
                  step={100}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </>
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default RoomList;